import { plaintextValidator } from '../fields';

const config = {};

export default {
  policyName: plaintextValidator({ mandatory: true }),
  parentPolicy: plaintextValidator({ mandatory: true })
};
